import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { queryFetch } from '@services/api';
import { ApiError } from '@root/globalTypes';
import { useQueryParams } from '@hooks/queryParams';
import { SchedulesAvailabilityProps, SchedulesAvailabilityRespSuccess } from './types';

const NO_MATCH = ['00000000-0000-0000-0000-000000000000'];

export const useGetSchedulesAvailability = ({
  from,
  to,
  scheduleId,
  taskType,
  userIds,
  assetIds,
  enabled = true,
}: SchedulesAvailabilityProps) => {
  const { parseParams } = useQueryParams();
  const active = Boolean(from && to) && enabled;
  const queryParams = parseParams(
    {
      from,
      to,
      scheduleId: scheduleId !== 'new' ? scheduleId : '',
      taskType,
      ...(userIds && { userIds: userIds.length ? userIds : NO_MATCH }),
      ...(assetIds && { assetIds: assetIds.length ? assetIds : NO_MATCH }),
    },
    { arrayFormat: 'bracket' },
  );

  const { data, isFetching } = useQuery<SchedulesAvailabilityRespSuccess, ApiError>({
    queryKey: [...queryKeys.schedules.availability, queryParams],
    queryFn: () => queryFetch({ url: `schedules_availability${queryParams}` }),
    placeholderData: (previousData) => previousData as SchedulesAvailabilityRespSuccess,
    enabled: active,
  });

  return { data: active ? data?.data : undefined, isFetching: isFetching && active };
};
